const InterviewListView = (resolve) => {
  require.ensure(['@/components/hrVenue/InterviewList'], () => {
    resolve(require('@/components/hrVenue/InterviewList'));
  });
};

const UserListView = (resolve) => {
  require.ensure(['@/components/users/Users'], () => {
    resolve(require('@/components/users/Users'));
  });
};

const InterviewAddEditView = (resolve) => {
  require.ensure(['@/components/hrVenue/InterviewCreateEdit'], () => {
    resolve(require('@/components/hrVenue/InterviewCreateEdit'));
  });
};

const InterviewDetailView = (resolve) => {
  require.ensure(['@/components/hrVenue/InterviewDetail'], () => {
    resolve(require('@/components/hrVenue/InterviewDetail'));
  });
};

const CandidateDetailView = (resolve) => {
  require.ensure(['@/components/hrVenue/InterviewCandidateDetail'], () => {
    resolve(require('@/components/hrVenue/InterviewCandidateDetail'));
  });
};

const InterviewCreateView = (resolve) => {
  require.ensure(['@/components/hrVenue/InterviewCreate'], () => {
    resolve(require('@/components/hrVenue/InterviewCreate'));
  });
};

const PricingListView = (resolve) => {
  require.ensure(['@/components/Pricing'], () => {
    resolve(require('@/components/Pricing'));
  });
};

const GeneralConditionsView = (resolve) => {
  require.ensure(['@/components/GeneralConditions'], () => {
    resolve(require('@/components/GeneralConditions'));
  });
};

const ContactUsView = (resolve) => {
  require.ensure(['@/components/Contact'], () => {
    resolve(require('@/components/Contact'));
  });
};

const FaqView = (resolve) => {
  require.ensure(['@/components/misc/Faq'], () => {
    resolve(require('@/components/misc/Faq'));
  });
};

// const BlogView = (resolve) => {
//   require.ensure(['@/components/Blog'], () => {
//     resolve(require('@/components/Blog'));
//   });
// };

// const BlogDetailView = (resolve) => {
//   require.ensure(['@/components/BlogDetail'], () => {
//     resolve(require('@/components/BlogDetail'));
//   });
// };

export const InterviewList = (MainNavbar, MainSidebarMenu) => ({
  path: 'interviews',
  name: 'HrVenueView',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: InterviewListView,
    // tab: SubSettingsMenu,
  },
  meta: {
    className: 'page-hr-venue',
    requiresAuth: true,
    // authenticate: "message.list",
    resource: 'interviews.PageTitle',
  },
});

export const QuestionGeneratorList = (MainNavbar, MainSidebarMenu) => ({
  path: 'question-generator',
  name: 'QuestionGeneratorList',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: InterviewListView,
  },
  meta: {
    className: 'page-hr-venue',
    requiresAuth: true,
    resource: 'questionList.PageTitle',
  },
  beforeEnter(to, from, next) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      page_type: 'question-list-listing',
      site_type: 'interview',
    });
    next();
  },
});

export const UserList = (MainNavbar, MainSidebarMenu) => ({
  path: 'users/',
  name: 'UserListView',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: UserListView,
    // tab: SubSettingsMenu,
  },
  meta: {
    className: 'page-hr-venue',
    requiresAuth: true,
    // authenticate: "message.list",
    resource: 'users.PageTitle',
  },
  beforeEnter(to, from, next) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      page_type: 'users',
      site_type: 'interview',
    });
    next();
  },
});

export const InterviewAdd = (MainNavbar, MainSidebarMenu) => ({
  path: 'create-interview/',
  name: 'InterviewAddView',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: InterviewAddEditView,
    // tab: SubSettingsMenu,
  },
  meta: {
    className: 'page-hr-venue-new',
    requiresAuth: true,
    // authenticate: "question.create",
    resource: 'createInterview.PageTitle',
  },
  beforeEnter(to, from, next) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      page_type: 'interview-create',
      site_type: 'interview',
    });
    next();
  },
});

export const QuestionGeneratorAdd = (MainNavbar, MainSidebarMenu) => ({
  path: 'question-generator-create/',
  name: 'QuestionGeneratorAddView',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: InterviewAddEditView,
    // tab: SubSettingsMenu,
  },
  meta: {
    className: 'page-hr-venue-new',
    requiresAuth: true,
    // authenticate: "question.create",
    resource: 'createQuestion.PageTitle',
  },
  beforeEnter(to, from, next) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      page_type: 'question-list-create',
      site_type: 'interview',
    });
    next();
  },
});

export const InterviewSend = (MainNavbar, MainSidebarMenu) => ({
  path: 'send-interview/:interviewId',
  name: 'InterviewSendView',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: InterviewCreateView,
    // tab: SubSettingsMenu,
  },
  meta: {
    className: 'page-hr-venue-new',
    requiresAuth: true,
    // authenticate: "question.create",
    resource: 'sendInterview.PageTitle',
  },
  beforeEnter(to, from, next) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      page_type: 'interview-send',
      site_type: 'interview',
    });
    next();
  },
});

export const InterviewEdit = (MainNavbar, MainSidebarMenu) => ({
  path: 'interview-edit/:interviewId',
  name: 'InterviewEditView',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: InterviewAddEditView,
    // tab: SubSettingsMenu,
  },
  meta: {
    className: 'page-hr-venue-edit',
    requiresAuth: true,
    // authenticate: "question.create",
    resource: 'editInterview.PageTitle',
  },
  beforeEnter(to, from, next) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      page_type: 'interview-edit',
      site_type: 'interview',
    });
    next();
  },
});

export const QuestionGeneratorEdit = (MainNavbar, MainSidebarMenu) => ({
  path: 'question-generator-edit/:interviewId',
  name: 'QuestionGeneratorEditView',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: InterviewAddEditView,
    // tab: SubSettingsMenu,
  },
  meta: {
    className: 'page-hr-venue-edit',
    requiresAuth: true,
    // authenticate: "question.create",
    resource: 'editQuestion.PageTitle',
  },
  beforeEnter(to, from, next) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      page_type: 'question-list-edit',
      site_type: 'interview',
    });
    next();
  },
});

export const InterviewDetail = (MainNavbar, MainSidebarMenu) => ({
  path: 'interview/:interviewId/detail',
  name: 'InterviewDetailView',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: InterviewDetailView,
    // tab: SubSettingsMenu,
  },
  meta: {
    className: 'page-hr-venue',
    requiresAuth: true,
    // authenticate: "question.create",
    resource: 'interviewDetail.PageTitle',
  },
});

export const CandidateDetail = (MainNavbar, MainSidebarMenu) => ({
  path: 'interview/candidate/:interviewCandidateLogId',
  name: 'CandidateDetailView',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: CandidateDetailView,
    // tab: SubSettingsMenu,
  },
  meta: {
    className: 'page-hr-venue-candidate-detail',
    requiresAuth: true,
    // authenticate: "question.create",
    resource: 'interviewCandidateDetail.PageTitle',
  },
  beforeEnter(to, from, next) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      page_type: 'candidate-evaluation',
      site_type: 'interview',
    });
    next();
  },
});

export const PricingList = (MainNavbar, MainSidebarMenu) => ({
  path: 'pricing',
  name: 'PricingListView',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: PricingListView,
    // tab: SubSettingsMenu,
  },
  meta: {
    requiresAuth: false,
    resource: 'PricingListView.PageTitle',
  },
  beforeEnter(to, from, next) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      page_type: 'pricing',
      site_type: 'interview',
    });
    next();
  },
});

export const GeneralConditions = (MainNavbar, MainSidebarMenu) => ({
  path: 'general-conditions/:tabName?',
  name: 'GeneralConditions',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: GeneralConditionsView,
  },
  meta: {
    className: 'page-general-conditions',
    requiresAuth: false,
    resource: 'GeneralConditions.PageTitle',
  },
});

export const ContactUs = (MainNavbar, MainSidebarMenu) => ({
  path: 'contact-us',
  name: 'ContactUs',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: ContactUsView,
  },
  meta: {
    className: 'page-general-contact',
    requiresAuth: false,
    resource: 'contactUs.PageTitle',
  },
});

export const FaqList = (MainNavbar, MainSidebarMenu) => ({
  path: 'faq',
  name: 'FaqList',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: FaqView,
  },
  meta: {
    className: 'page-general-conditions',
    requiresAuth: true,
    resource: 'faq.PageTitle',
  },
});

// export const BlogList = (MainNavbar, MainSidebarMenu) => ({
//   path: '/blog',
//   name: 'BlogListView',
//   components: {
//     top: MainNavbar,
//     sidebar: MainSidebarMenu,
//     content: BlogView,
//   },
//   meta: {
//     requiresAuth: true,
//     resource: 'BlogListView.PageTitle',
//   },
//   beforeEnter(to, from, next) {
//     window.dataLayer = window.dataLayer || [];
//     dataLayer.push({
//       page_type: 'blog-listing',
//       site_type: 'interview',
//     });
//     next();
//   },
// });

// export const BlogDetail = (MainNavbar, MainSidebarMenu) => ({
//   path: '/blog/:slug',
//   name: 'BlogDetail',
//   components: {
//     top: MainNavbar,
//     sidebar: MainSidebarMenu,
//     content: BlogDetailView,
//   },
//   meta: {
//     requiresAuth: true,
//     resource: 'BlogDetail.PageTitle',
//   },
//   beforeEnter(to, from, next) {
//     window.dataLayer = window.dataLayer || [];
//     dataLayer.push({
//       page_type: 'blog-detail',
//       site_type: 'interview',
//     });
//     next();
//   },
// });
